import React from 'react'
import { cn } from '@/lib/utils'

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode
  variant?: 'default' | 'success' | 'warning' | 'error' | 'info' | 'outline'
}

export function Badge({
  className,
  children,
  variant = 'default',
  ...props
}: BadgeProps) {
  const variants = {
    default: 'bg-brand-gray/20 text-brand-gray',
    success: 'bg-success/20 text-success',
    warning: 'bg-warning/20 text-warning',
    error: 'bg-error/20 text-error',
    info: 'bg-info/20 text-info',
    outline: 'bg-transparent border-brand-gray/30 text-brand-gray'
  }

  return (
    <span
      className={cn(
        'inline-flex items-center px-2 py-1 rounded-full text-xs font-medium',
        'border border-current/20',
        variants[variant],
        className
      )}
      {...props}
    >
      {children}
    </span>
  )
}